module.exports = __webpack_public_path__ + "assets/media/bolt-trio-pink.44940f78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/bolt-trio-pink.svg
// module id = 1097
// module chunks = 0